import { ensureInstanceArray } from "../../utils/typeUtils";
import type { THarmCategory } from "../risk/Harm";
import { Hazard } from "../risk/Hazard";
import type { TRiskRank } from "../risk/Risk";

export class OperationalRecommendation{
    description!: string;
    label!: string;
    constructor(init?: Partial<OperationalRecommendation>) {
        Object.assign(this, init);
    }
}


export class MitigationRequirement{

    description: string = "";
    label: string = "";
    lifeCycleStage: string = "";
    accountableOwner: string = "";
    conditionsOfAcceptability: string = "";
    constructor(init?: Partial<MitigationRequirement>) {
        Object.assign(this, init);
    }
}

export class DeployerImpact{
    description: string = "";
    impactArea: string = "";
    label: string = "";
    constructor(init?: Partial<DeployerImpact>) {
        Object.assign(this, init);
    }
}

export class RiskRegistryItem {

    id: string = "";
    label: string = "";
    harmCategory: THarmCategory = "" as THarmCategory;
    riskOwner: string = "";
    
    lifeCycleStage: string = "Foundation"
    riskRank: TRiskRank = "" as TRiskRank;
    riskScenarioDescription: string = "";
    operationalRecommendations: OperationalRecommendation[] = [];
    causalHazards: Hazard[] = [];
    deployerImpact: DeployerImpact[] = [];
    mitigationRequirements: MitigationRequirement[] = [];
    enablingFactors: Hazard[] = [];

    constructor(init?: Partial<RiskRegistryItem>) {
        Object.assign(this, init);
        
        this.operationalRecommendations = ensureInstanceArray(this.operationalRecommendations, OperationalRecommendation);
        this.causalHazards = ensureInstanceArray(this.causalHazards, Hazard);
        this.deployerImpact = ensureInstanceArray(this.deployerImpact, DeployerImpact);
        this.mitigationRequirements = ensureInstanceArray(this.mitigationRequirements, MitigationRequirement);
        this.enablingFactors = ensureInstanceArray(this.enablingFactors, Hazard);
    }
}
   